// @flow

import Environments from '../constants/Environments';
import { config } from './Helpers';

export default class Environment {
  #environment: string;
  #locale: string;
  #country: string;

  /**
   * Create a new Environment class
   */
  constructor() {
    this.#environment = config('env', 'APP_ENV');

    const locale = document.documentElement.getAttribute('lang');
    if (!locale) {
      throw new Error('The locale is not defined on the HTML tag');
    }
    this.#locale = locale;
    this.#country = locale.split('-')[1];
  }

  /**
   * Check if the current environment is local
   */
  isLocal(): boolean {
    return this.#environment === Environments.LOCAL;
  }

  /**
   * Check if the current environment is the production environment
   */
  isProduction(): boolean {
    return this.#environment === Environments.PRODUCTION;
  }

  /**
   * Get the current environment
   */
  get(): string {
    return this.#environment;
  }

  /**
   * get the environment locale
   */
  get locale(): string {
    return this.#locale;
  }

  /**
   * Get the country
   */
  get country(): string {
    return this.#country;
  }
}
